import { useState, useEffect } from "react";
import {
  getAllBloggers,
  getLineManager,
  getAllLeaveTypes,
  getAllTypes,
  getAllDesignations,
  getAllIndustries,
  getAllRoles,
  getAllExperienceLevel,
  getAllJobType,
  getAllOffices,
  getAllStatus,
  getHrAndAdminAuthors,
  getAllCategoriesTypes,
  getAllManager,
} from "../utils/methods";

const useFetchOptions = () => {
  const [bloggers, setBloggers] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [blogTypes, setBlogTypes] = useState([]);
  const [wikkiCategories, setWikkiCategories] = useState([]);
  const [jobIndustry, setJobIndustry] = useState([]);
  const [jobRole, setJobRole] = useState([]);
  const [jobExpLevel, setJobExpLevel] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [allJobOffices, setAllJobOffices] = useState([]);
  const [employeeDesignation, setEmployeeDesignation] = useState([]);
  const [applicantStatus, setApplicantStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lineManager, setLineManager] = useState(null);
  const [managers, setManagers] = useState("");
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [
          fetchedBloggers,
          fetchedLineManager,
          fetchedAuthors,
          fetchedTypes,
          fetchedCategories, // This must match `getAllCategoriesTypes` in the order
          fetchedDesignation,
          fetchedIndustries,
          fetchedRoles,
          fetchedExpLevels,
          fetchedJobTypes,
          fetchedOffices,
          fetchedStatus,
          fetchedLeaveTypes,
          fetchedManager,
        ] = await Promise.all([
          getAllBloggers(),
          getLineManager(),
          getHrAndAdminAuthors(),
          getAllTypes(),
          getAllCategoriesTypes(), // This was previously misplaced
          getAllDesignations(),
          getAllIndustries(),
          getAllRoles(),
          getAllExperienceLevel(),
          getAllJobType(),
          getAllOffices(),
          getAllStatus(),
          getAllLeaveTypes(),
          getAllManager(),
        ]);
        setManagers(fetchedManager);
        setBloggers(fetchedBloggers);
        setLineManager(fetchedLineManager);
        setAuthors(fetchedAuthors);
        setBlogTypes(Array.isArray(fetchedTypes) ? fetchedTypes : []);
        setWikkiCategories(
          Array.isArray(fetchedCategories) ? fetchedCategories : []
        ); // This now maps correctly
        setEmployeeDesignation(
          Array.isArray(fetchedDesignation) ? fetchedDesignation : []
        );
        setJobIndustry(
          Array.isArray(fetchedIndustries) ? fetchedIndustries : []
        );
        setJobRole(Array.isArray(fetchedRoles) ? fetchedRoles : []);
        setJobExpLevel(Array.isArray(fetchedExpLevels) ? fetchedExpLevels : []);
        setJobType(Array.isArray(fetchedJobTypes) ? fetchedJobTypes : []);
        setAllJobOffices(Array.isArray(fetchedOffices) ? fetchedOffices : []);
        setApplicantStatus(Array.isArray(fetchedStatus) ? fetchedStatus : []);
        setLeaveTypes(
          Array.isArray(fetchedLeaveTypes) ? fetchedLeaveTypes : []
        );
      } catch (err) {
        console.error("Error fetching options:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  return {
    bloggers,
    authors,
    wikkiCategories,
    leaveTypes,
    employeeDesignation,
    applicantStatus,
    blogTypes,
    jobIndustry,
    jobExpLevel,
    jobRole,
    jobType,
    allJobOffices,
    loading,
    error,
    lineManager,
    managers,
  };
};

export default useFetchOptions;
